/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

/* Library imports */

/* Component imports */

/* Style imports */

import ConstantsLg from "./ConstantsLg";
import { FrontEndErrorNotification } from "./Services/services";
/*** End Imports ***/

export function bindThisToAll(_this, ...methods) {
    methods.map(method => _this[method] = _this[method].bind(_this));
}

/* go to think over it */
export function useOverlay(elId, type) {
    let div = document.createElement("div");
    div.className = "overlay " + type;
    document.getElementById(elId).appendChild(div);
}

export function getGoogleClientId(buildMode) {
    if (buildMode === 1) {
        return '163719487231-labucev0vha84aildikfgtvsgbo0kq3h.apps.googleusercontent.com'
    }
    else if (buildMode === 2) {
        return '1051340654667-qebbq3b9p9a7a9416ppdjbeldovj4dos.apps.googleusercontent.com'
    }
    else if (buildMode === 3) {
        return '973957232952-pi43gd8n8si3p04svcg1jarorgd97d3a.apps.googleusercontent.com'
    }
    else if (buildMode === 4) {
        return '118088068986-282idk6ht9vl6vokn2b1811ipt495vmb.apps.googleusercontent.com'
    }
}

export function getFacebookAppIdId(buildMode) {
    if (buildMode === 1) {
        return '852202851496162'
    }
    else if (buildMode === 2) {
        return '1104997622900485'
    }
    else if (buildMode === 3) {
        return '1093202320745412'
    }
    else if (buildMode === 4) {
        return '876284919160922'
    }
}


export function getBrowserAndBrowserVersion() {
    var browser = '';
    var browserVersion = 0;

    if (/Opera[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
        browser = 'Opera';
    } else if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        browser = 'MSIE';
    } else if (/Navigator[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
        browser = 'Netscape';
    } else if (/Chrome[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
        browser = 'Chrome';
    } else if (/Safari[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
        browser = 'Safari';
        /Version[\/\s](\d+\.\d+)/.test(navigator.userAgent);
        browserVersion = new Number(RegExp.$1);
    } else if (/Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent)) {
        browser = 'Firefox';
    }
    if (browserVersion === 0) {
        browserVersion = parseFloat(new Number(RegExp.$1));
    }

    return browser + '*' + browserVersion

}

export function FrontEndErrorEmail(error) {
    let browser = getBrowserAndBrowserVersion();
    let formData = new FormData();
    console.log(error.stack);
    console.log(browser);
    formData.append('error', error.stack);
    formData.append('browser', browser);
    FrontEndErrorNotification(formData, () => { }, () => { })
}

// WEBPACK FOOTER //
// ./src/UtilityLg.js


// WEBPACK FOOTER //
// ./src/UtilityLg.js